import {getActiveOption} from './common';
import {
  FLOP_TYPE,
} from '../constants/board';
import {TYPE_POC} from '../constants/types'

export const getPreparedBoardProps = (state) => {
  const settings = state.settings.toJS();
  const activeField = state.board.get('activeField') && state.board.get('activeField').toJS();
  const winner = state.board.get('winner') && state.board.get('winner').toJS();
  const carousel = state.board.get('carousel') && state.board.get('carousel').toJS();
  const players = state.board.get('players').toJS();
  const isPOC = settings.id === TYPE_POC;
  const activeRules = getActiveOption(settings.rules).rules;
  const noCommunityCards = activeRules.noCommunityCards;
  const hiLo = activeRules.hiLo;

  const isWinnerCard = (card) => {
    if (winner) {
      return winner.cards.find(winnerCard => {
        return winnerCard.suit.id === card.suit.id && winnerCard.rank.id === card.rank.id;
      })
    }
    return false
  };

  const isNotWinnerPlayer = (player) => {
    return !!(winner && !winner.ids.includes(player.id));
  };

  const getVisibleSlides = (width) => {
    const cardsCount = players[0].hand.length;
    if (width > 550 && cardsCount < 4 && players.length >= 3) {
      return 3
    }
    if (width <= 500 && cardsCount >= 6) {
      return 1
    }
    if (width <= 400 && cardsCount >= 4) {
      return 1
    }
    return 2
  };

  const getCurrentSlide = (visibleSlides) => {
    if (!activeField.type && (players.length > 2)) {
      return 0
    }
    if ((players.length <= visibleSlides) || (activeField.id === 0)) {
      return 0
    }
    if (isPOC) {
      return activeField.id - 1;
    }
    if ((activeField.id + 1) === players.length) {
      return activeField.id - 2
    }

    return activeField.id - 1;
  };

  const isSplitPotWinner = (playerId) => {
    return winner && (winner.ids.length > 1) && winner.ids.includes(playerId);
  };

  const isOddsWinner = (playerWinPercent) => {
    return parseFloat(playerWinPercent) === getHighestWinPercent(players)
      ? activeField
      : false
  };

  const isCardChosen = (type, card, index) => {
    const isActiveCard = activeField.card.type === FLOP_TYPE
      ? activeField.card.type === type && activeField.card.id === index
      : activeField.card.type === type;

    return isActiveCard || isWinnerCard(card)
  };

  return {
    table: state.board.get('table').toJS(),
    hints: state.hints.get('hints').toJS(),
    activeField,
    players,
    winner,
    carousel,
    settings,
    activeRules,
    isPOC,
    noCommunityCards,
    hiLo,
    isWinnerCard,
    isNotWinnerPlayer,
    getVisibleSlides,
    getCurrentSlide,
    isSplitPotWinner,
    isOddsWinner,
    isCardChosen,
  };
};

export const getHighestWinPercent = (players) => {
  const winPercents = players.map((player) => {
    if (player.win) {
      return parseFloat(player.win)
    }
    return false
  });
  return Math.max(...winPercents)
};

export const isActivePlayer = (players, player, activeField, winner) => {
  if (((player.id === activeField.id + 1)
    && (activeField.type === 'player'))
    || (winner && winner.ids.includes(player.id))
  ) {
    return activeField
  }

  return false
};